<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Edit Mobile Money Beneficiary </h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="editIdmobileMoneyBeneficiary(editIdmobileMoneyBeneficiaryForm.value)" [formGroup]="editIdmobileMoneyBeneficiaryForm">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">

                      <div class="col-6">
                        <mat-form-field class="example-full-width input-tel">
                          <input matInput placeholder="Beneficiary First Name" formControlName="beneficiary_fname" maxlength="50" required />
                          <mat-error *ngIf="submitted && f.beneficiary_fname?.errors?.required">
                            Enter Beneficiary First Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_fname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-6">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Last Name" formControlName="beneficiary_lname" maxlength="50" required />

                          <mat-error *ngIf="submitted && f.beneficiary_lname?.errors?.required">
                            Enter Beneficiary Last Name
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_lname?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <mat-form-field>
                          <input matInput placeholder="Beneficiary Address" formControlName="beneficiary_address" maxlength="150" required />

                          <mat-error *ngIf="submitted && f.beneficiary_address?.errors?.required">
                            Enter Beneficiary Address
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_address?.errors?.pattern">
                            Enter Alphabet character
                          </mat-error>

                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field class="example-full-width input-tel">
                          <input type="tel" matInput placeholder="Beneficiary Mobile Money No. with Country Code"
                                 formControlName="beneficiary_phone" Numberonly minlength="1" maxlength="20" required />
                          <p style="color: red;">Note : Kindly enter phone number with country code</p>
                          <mat-error *ngIf="submitted && f.beneficiary_phone?.errors?.required">
                            Beneficiary Mobile Money No. with Country Code is required
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.maxlength">
                            Maximum Length Beneficiary Mobile Money No. is 20
                          </mat-error>
                          <mat-error *ngIf="f.beneficiary_phone?.errors?.minlength">
                            Minimum Length Beneficiary Mobile Money No. is 1
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-6">
                        <mat-form-field>
                          <input matInput type="email" placeholder="Beneficiary Email" formControlName="beneficiary_email" maxlength="100" required />
                          <mat-error *ngIf="submitted && f.beneficiary_email.errors">
                            Enter Valid Email
                          </mat-error>
                        </mat-form-field>
                      </div>


                      <div class="col-6">
                        <mat-form-field class="example-full-width">
                          <mat-label> Sender Fund Source</mat-label>
                          <mat-select formControlName="senderSourceOfFund" required>
                            <mat-option [value]="d?.data" *ngFor="let d of senderSourceOfFundlist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.senderSourceOfFund?.errors?.required">
                            Select Sender Fund Source
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-6">
                        <mat-form-field class="example-full-width">
                          <mat-label> Remittance Purpose</mat-label>
                          <mat-select formControlName="purposeofremittance" required>
                            <mat-option [value]="d?.data" *ngFor="let d of purposeofremittancelist; let i=index">
                              {{d?.value}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.purposeofremittance?.errors?.required">
                            Select Remittance Purpose
                          </mat-error>
                        </mat-form-field>
                      </div>




                    </div>
                  </div>


                  <div class="col-12">
                    <button class="primary-btn" type="submit"> UPDATE</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>


  </div>

</fieldset>
